import React from 'react';
import Icon from '../../../components/AppIcon';

const FirstTimeUserGuide = () => {
  const benefits = [
    {
      icon: 'Zap',
      title: 'No Password Required',
      description: 'Access your account instantly without remembering complex passwords'
    },
    {
      icon: 'Shield',
      title: 'Enhanced Security',
      description: 'Magic links are more secure than traditional password authentication'
    },
    {
      icon: 'Clock',
      title: 'Quick Access',
      description: 'Get authenticated in seconds with a single click from your email'
    },
    {
      icon: 'Smartphone',
      title: 'Mobile Friendly',
      description: 'Access admin tools from any device, anywhere you need them'
    }
  ];

  return (
    <div className="mt-8 space-y-6">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-2">First Time Here?</h3>
        <p className="text-sm text-muted-foreground">
          Learn about our password-less authentication system
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className="flex items-start space-x-3 p-4 bg-card border border-border rounded-lg hover:shadow-elevation-1 transition-smooth"
          >
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg flex-shrink-0">
              <Icon name={benefit?.icon} size={20} color="var(--color-primary)" strokeWidth={2} />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-semibold text-foreground mb-1">{benefit?.title}</h4>
              <p className="text-xs text-muted-foreground">{benefit?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-muted/30 border border-border rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} color="var(--color-primary)" strokeWidth={2} className="mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground mb-2">How It Works</p>
            <ol className="text-xs text-muted-foreground space-y-1 list-decimal list-inside">
              <li>Enter your corporate email address</li>
              <li>Check your inbox for the magic link email</li>
              <li>Click the link to authenticate instantly</li>
              <li>Access all fleet management tools securely</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstTimeUserGuide;